import React, { useState, useEffect } from 'react';
import { getStaticProps as getStaticPropsMethod } from '@/bit/pages/pages.create-pages';
import { getClientType, sendTaggingInfo } from '@/utils/common';
import { wrapper } from 'store';
import BafClientForm from '@/forms/client/au/baf';
import BafNoClientForm from '@/forms/noClient/au/baf';
import { CLIENT_TYPE } from '@/constants/constant';
import { PATH_NAME, URL_SEO } from '@/constants/pages/baf';
import sendToRelogin from '@gcloud-npm/utils.page.send-to-relogin';
import MetaData from '@/bit/core/core.meta-data';
import { actions as samActions } from '@/reducers/sam-reducer';
import { useDispatch, useSelector } from 'react-redux';

const Baf = ({ seoInfo }) => {
  const dispatch = useDispatch();
  const testVersion = useSelector((state) => state.sam.testVersion);
  const [clientType, setClientType] = useState('');

  useEffect(() => {
    const clientStatus = getClientType();
    dispatch(
      samActions.getTestVersionSam({
        testName: 'test-already-client',
      })
    );
    if (clientStatus === CLIENT_TYPE.CLIENT) {
      setClientType(CLIENT_TYPE.CLIENT);
    } else if (clientStatus === CLIENT_TYPE.SOFT_CLIENT) {
      sendToRelogin();
    } else {
      setClientType(CLIENT_TYPE.NO_CLIENT);
    }
  }, []);

  useEffect(() => {
    if (testVersion) {
      sendTaggingInfo(
        { testName: 'proceso-baf', testVersion },
        '',
        'testab_sam'
      );
    }
  }, [testVersion]);

  return (
    <>
      <MetaData seoInfo={seoInfo} />
      {testVersion && clientType && clientType === CLIENT_TYPE.CLIENT && <BafClientForm />}
      {testVersion && clientType && clientType === CLIENT_TYPE.NO_CLIENT && (
        <BafNoClientForm />
      )}
    </>
  );
};
export default Baf;

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  return getStaticPropsMethod(data, '', 2, {
    pathname: PATH_NAME.AU,
    orionAlias: '',
    seoLocation: URL_SEO,
    headerLocation: '/',
    layoutInfo: '',
  });
});
